import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${pxToRem('26px')};
  max-width: 100%;
  justify-content: center;
  align-items: center;
`;

export const RoleIcon = styled.div`
  background: url(${props => props.icon});
  background-repeat: no-repeat;
  width: ${pxToRem('20px')};
  height: ${pxToRem('20px')};
  background-size: contain;
`;
